module.exports = __webpack_public_path__ + "img/zhzl-bg.6c3b7b71.png";